export const name = 'qaApi' as const
export const QaApiSymbol = Symbol('qaApiSymbol')
